import { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { useNavigate, NavLink } from "react-router-dom";
import logo from "../../../assets/images/logo-cozimax.png";
import Style from "./index.module.css";

export const Sidebar = ({ items = [] }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => setOpen(!open);

  return (
    <>
      <button
        className={`${Style.menuBtn} ${open ? Style.openBtn : ""}`}
        onClick={toggleSidebar}
      >
        {open ? <FaTimes size={18} /> : <FaBars size={22} />}
      </button>

      <aside className={`${Style.sidebar} ${open ? Style.open : ""}`}>
        <div className={Style.logo}>
          <img
            src={logo}
            alt="Logo"
            style={{ cursor: "pointer", height: "60px" }}
            onClick={() => navigate("/home")}
          />
        </div>

        <nav className={Style.nav}>
          {items.map(({ url, description, icon }, index) => (
            <NavLink
              key={index}
              to={url}
              className={({ isActive }) =>
                `${Style.navItem} ${isActive ? Style.active : ""}`
              }
            >
              {icon} <span>{description}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
};
